import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import css from '@/components/layout/Layout.module.css'

const adminNavItems = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/applications', label: 'Applications' },
  { to: '/admin/orders', label: 'Orders' },
  { to: '/admin/quotes', label: 'Quotes' },
  { to: '/admin/organizations', label: 'Organizations' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/catalog', label: 'Catalog' },
  { to: '/admin/settings', label: 'Settings' },
]

export function AdminLayout() {
  const { signOut } = useAuth()

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside style={{
        position: 'fixed', top: 0, left: 0, bottom: 0, width: 240,
        background: '#1a1a2e', color: 'white', display: 'flex', flexDirection: 'column',
        zIndex: 200,
      }}>
        <div style={{ padding: 'var(--space-4)', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', gap: 'var(--space-3)', height: 56 }}>
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#3d7ab8"/>
            <text x="16" y="22" textAnchor="middle" fill="white" fontFamily="Space Grotesk" fontWeight="700" fontSize="16">K</text>
          </svg>
          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700 }}>Keder Admin</span>
        </div>

        <nav style={{ flex: 1, padding: 'var(--space-4) var(--space-2)', display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
          {adminNavItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `${css.navItem} ${isActive ? css.navItemActive : ''}`}
            >
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: 'var(--space-4)', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <a href="/gaviota" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 'var(--text-sm)', display: 'block', marginBottom: 'var(--space-2)' }}>Back to Portal</a>
          <button onClick={signOut} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', fontSize: 'var(--text-sm)', cursor: 'pointer' }}>Sign out</button>
        </div>
      </aside>

      <div style={{ flex: 1, marginLeft: 240, display: 'flex', flexDirection: 'column' }}>
        <header style={{
          height: 56, display: 'flex', alignItems: 'center', padding: '0 var(--space-8)',
          background: 'var(--color-bg-elevated)', borderBottom: '1px solid var(--color-border-subtle)',
          position: 'sticky', top: 0, zIndex: 100,
        }}>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Administration Console</span>
        </header>
        <div style={{ flex: 1, padding: 'var(--space-8)', maxWidth: 'var(--container-max)', width: '100%', margin: '0 auto' }}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
